export const triangulate = (pts, step) => {
    // partition by y-axis
    if (pts.length === 0) {
        return [];
    }
    let rows = {};
    let maxY = Math.max(...pts.map(p => p.y));
    let minY = Math.min(...pts.map(p => p.y));
    pts.forEach(pt => {
        let {x,y} = pt;
        if (!rows[y]) { 
            rows[y] = [];
        }
        rows[y].push(pt);
    });

    let triangles = [];
    let lastRow = rows[minY];
    let lastY = minY;
    while (true) {
        let row1 = lastRow;
        let nextY = nextRow(rows, lastY);
        let row2 = rows[nextY];
        lastY = nextY;
        lastRow = row2;
        if (!row1 || !row2) {
            break;
        }
        triangles = [ ... triangles, ...triangulateRow(row1, row2)];;
    }
    return triangles;
};

const nextRow = (rows, i) => {
    let keys = Object.keys(rows).map(x => parseInt(x));
    for (let y of keys) {
        if (y > i) {
            return y;
        }
    }
};

const triangulateRow = (a,b) => {
    let triangles = [];
    for (let i=0; i < a.length - 1; i++ ){
        let pt_a1 = a[i];
        let pt_a2 = a[i+1];

        let pt_b1 = b.find(pt => pt.x === pt_a1.x);
        let pt_b2 = b.find(pt => pt.x === pt_a2.x);
        
        if (pt_b1 && pt_a2) {
            triangles.push([pt_a1, pt_b1, pt_a2]);
        }

        if (pt_b2 && pt_a2 && pt_b1) {
            triangles.push([pt_b1, pt_b2, pt_a2]);
        }
    }
    return triangles;
};

export const contour = (triangles, threshold=2) => {
    let contourSegments = [];
    for (let triangle of triangles) {
        let above = triangle.filter(x => x.dist >= threshold);
        let below = triangle.filter(x => x.dist < threshold);

        if (below.length === 0 || above.length === 0) {
            continue;
        }

        let minority = above.length < below.length ? above : below;
        let majority = above.length > below.length ? above : below;

        let contourPoints = [];

        let crossedEdges = [[minority[0], majority[0]],
                            [minority[0], majority[1]]];

        for (let edge of crossedEdges) {
            let [e1, e2] = [edge[0], edge[1]];

            let how_far = ((threshold - e2.dist)
                           / (e1.dist - e2.dist));
            let crossing_point = {
                x: how_far * e1.x + (1-how_far) * e2.x,
                y: how_far * e1.y + (1-how_far) * e2.y
            };
            contourPoints.push(crossing_point);
        }

        if (contourPoints[0].x === contourPoints[1].x &&
            contourPoints[0].y === contourPoints[1].y) {
            continue;
        }
        contourSegments.push([contourPoints[0], contourPoints[1]]);
    }

    return contourSegments;
};

export const joinSegments = (segments) => {
    let unusedSegments = [... segments];
    let segmentPoints = {};

    for (let segment of segments) {
        let [e1, e2] = segment;
        e1 = str(e1);
        e2 = str(e2);
        if (!segmentPoints[e1]) {
            segmentPoints[e1] = [];
        }
        if (!segmentPoints[e2]) {
            segmentPoints[e2] = [];
        }
        segmentPoints[e1].push(segment);
        segmentPoints[e2].push(segment);
    }
    
    let contourLines = [];

    while (unusedSegments.length > 0) {
        let line = unusedSegments.shift();
        
        while (true) {
            let tailCandidates = intersect(segmentPoints[str(last(line))], unusedSegments);
            if (tailCandidates.length > 0) {
                let tail = tailCandidates.pop();
                if (tail[1].x === last(line).x &&
                    tail[1].y === last(line).y) {
                    line.push(tail[0]);
                } else {
                    line.push(tail[1]);
                }
                unusedSegments = unusedSegments.filter(
                    x => x !== tail);
            }

            let headCandidates = intersect(segmentPoints[str(line[0])], unusedSegments);
            if (headCandidates.length > 0) {
                let head = headCandidates.pop();
                line.unshift(head[1].x === line[0].x && head[1].y === line[0].y ? head[0] : head[1]);
                unusedSegments = unusedSegments.filter(
                    x => x !== head);
            }

            if ((headCandidates.length===0) &&
                (tailCandidates.length ===0)) {
                contourLines.push(line);
                break;
            }
        }

    }

    return contourLines;
};

const last = (l) => l[l.length - 1];

const intersect = (a,b) => {
    if (!a) {
        return [];
    }
    return a;
    return a.filter(
        _a => b.some(_b => _b.x === _a.x && _b.y === _a.y));
};

const str = (pt) => pt.x+','+pt.y;
